export const BLOCK_REFERENCE_COLUMNS = [
    {
        table: 'placement',
        column: 'anchor_block_id',
        valueType: 'uuid',
        kind: 'authored',
        onMove: 'rehome',
        onVanish: 'flag',
        owner: '1.L-2',
        since: 'exit-1b',
    },
    {
        table: 'play_record',
        column: 'block_id',
        valueType: 'uuid',
        kind: 'authored',
        onMove: 'rehome',
        onVanish: 'flag',
        owner: '1.M-1',
        since: 'exit-1b',
    },
    {
        table: 'secret',
        column: 'block_id',
        valueType: 'uuid',
        kind: 'derived',
        onMove: 'rederive',
        onVanish: 'orphan',
        owner: '1.M-1',
        since: 'exit-1b',
    },
    {
        table: 'asset_pending',
        column: 'block_id',
        valueType: 'uuid',
        kind: 'authored',
        onMove: 'rehome',
        onVanish: 'flag',
        owner: '1.R',
        since: 'editor-alpha',
    },
    {
        table: 'session_item',
        column: 'block_id',
        valueType: 'uuid',
        kind: 'authored',
        onMove: 'rehome',
        onVanish: 'flag',
        // CS r5a (DECISIONS 212 item 18): 2.C s1 re-homes it through 1.A's registry.
        owner: '2.C',
        since: 'exit-2b',
    },
    {
        // Journal pages and secret sections.
        table: 'foundry_map',
        column: 'sub_key',
        valueType: 'text',
        kind: 'authored',
        onMove: 'rehome',
        onVanish: 'flag',
        owner: '5.B',
        since: 'exit-5',
    },
    {
        table: 'ai_proposal',
        column: 'target_block_id',
        valueType: 'uuid',
        kind: 'authored',
        onMove: 'rehome',
        onVanish: 'stale',
        owner: '3.D',
        since: 'exit-3a',
    },
    {
        table: 'block_index',
        column: 'block_id',
        valueType: 'uuid',
        kind: 'derived',
        onMove: 'rederive',
        onVanish: 'rederive',
        owner: '1.A',
        since: 'editor-alpha',
    },
    {
        table: 'mention',
        column: 'block_id',
        valueType: 'uuid',
        kind: 'derived',
        onMove: 'rederive',
        onVanish: 'rederive',
        owner: '1.A',
        since: 'editor-alpha',
    },
    {
        table: 'asset_ref',
        column: 'block_id',
        valueType: 'uuid',
        kind: 'derived',
        onMove: 'rederive',
        onVanish: 'rederive',
        owner: '1.A',
        since: 'editor-alpha',
    },
];
export const NOT_BLOCK_REFERENCE_COLUMNS = [
    {
        table: 'block_index',
        column: 'parent_block_id',
        reason: 'derived structure, rewritten with its own block_index row',
    },
    {
        table: 'asset_pending',
        column: 'notion_block_id',
        reason: "a Notion block id, not one of this app's block ids",
    },
];
//# sourceMappingURL=rows-block-references.js.map